import { Article } from '@work4all/models/lib/Classes/Article.entity';
import { EMode } from '@work4all/models/lib/Enums/EMode.enum';
import { Entities } from '@work4all/models/lib/Enums/Entities.enum';

import { useEntityPreviewData } from '../hooks/use-entity-preview-data';
import { EntityPreviewContainerProps } from '../types';

import { ArticlePreview } from './ArticlePreview';

type ArticlePreviewContainerProps = EntityPreviewContainerProps;
export const articlePreviewFields: Article<EMode.query> = {
  id: null,
  name: null,
  number: null,
  unit: {
    id: null,
    name: null,
  },
  longtext: null,
  entryPrice: null,
  articleGroup: {
    id: null,
    name: null,
  },
  groupId: null,
  articleDocumentList: {
    file: {
      id: null,
      fileInfos: {
        previewUrl: null,
        previewMimeType: null,
        fileServiceProviderInfos: {
          id: null,
          exists: null,
        },
      },
    },
    articleImage: {
      id: null,
      fileInfos: {
        previewUrl: null,
        previewMimeType: null,
        fileServiceProviderInfos: {
          id: null,
          exists: null,
        },
      },
    },
  },
  hasBulkPrices: null,
  bulkPriceList: [
    {
      id: null,
      sdObjMemberCode: null,
      price: null,
      bulkPriceTierItem: {
        id: null,
        name: null,
        edgeValue1: null,
        edgeValue2: null,
      },
      priceGroupId: null,
    },
  ],
  articlePrices: {
    singlePriceList: [
      {
        id: null,
        priceGroupId: null,
        priceGroup: {
          id: null,
          name: null,
          currency: { id: null, name: null },
        },
        price: null,
        surcharge: null,
        minuteWage: null,
        isFixedPrice: null,
      },
    ],
    customerIndividualPriceList: [
      {
        id: null,
        articleId: null,
        netPrice: null,
        customerId: null,
        currency: {
          id: null,
          name: null,
        },
      },
    ],
    purchasePriceList: [
      {
        id: null,
        supplier: {
          id: null,
          number: null,
          name: null,
        },
        supplierId: null,
        factor: null,
        validFromDate: null,
        listPrice: null,
        discount: null,
        purchasePrice: null,
        supplierText: null,
        orderAmount: null,
        deliveryTime: null,
        articleId: null,
        articleNumber: null,
        currency: {
          id: null,
          name: null,
        },
        note: null,
        unitId: null,
        unit: {
          id: null,
          name: null,
          factor: null,
        },
        amountPerUnit: null,
      },
    ],
  },
  standardImageId: null,
};

export const ArticlePreviewContainer = (
  props: ArticlePreviewContainerProps
) => {
  const {
    ids,
    onCloseClick,
    onEditClicked,
    onShareClicked,
    convertProps,
    onVisibilityToggle,
  } = props;

  const articleId = ids[0];
  const articles = useEntityPreviewData<Article>(
    [articleId],
    Entities.article,
    articlePreviewFields
  );

  if (!articles) {
    return null;
  }

  return (
    <ArticlePreview
      onCloseClick={onCloseClick}
      onEditClicked={onEditClicked}
      articles={articles}
      onShareClicked={onShareClicked}
      convertProps={convertProps}
      onVisibilityToggle={onVisibilityToggle}
    />
  );
};
